<script setup>
import { isArray, isEmpty } from 'lodash';
import { computed, ref } from 'vue';

// Es como el SelectCifra pero la selección la va almacenando en un input oculto
// TODO: Revisar porque SelectCifra ya pone el input oculto solo
const props = defineProps({
  inputName: { type: String, required: true },
  options: { type: Array, required: true },
  trackBy: { type: String, required: true },
  seleccionInicial: { type: Array, default: () => ([]) },
  // Si está a true, en el input solo irán los ids de los registros, no todo el json
  inputSoloTrackBy: { type: Boolean, default: false },
});

const seleccion = ref();

if (!isEmpty(props.seleccionInicial)) {
  seleccion.value = props.options.filter((op) => (
    props.seleccionInicial.includes(op[props.trackBy])
  ));
}

const inputValue = computed(() => {
  if (props.inputSoloTrackBy) {
    if (isArray(seleccion.value)) {
      return seleccion.value?.map((s) => s[props.trackBy]).join(',');
    }
    return seleccion.value ? seleccion.value[props.trackBy] : null;
  }

  return JSON.stringify(seleccion.value);
});
</script>

<template>
  <input type="hidden" :name="inputName" :value="inputValue">
  <select-cifra
    v-model="seleccion"
    :options="options"
    :track-by="trackBy"
    v-bind="$attrs"
  >
  </select-cifra>
</template>
